import React from 'react';
import ModulePagination from './ModulePagination';

const ModulePageContainer: React.FC = () => {
    return (
        <div>
            <ModulePagination />
        </div>
    )
}

export default ModulePageContainer;